import { ErrorMessage } from 'formik'
import TextError from './TextError'
import { useStyles } from './styles'
import React, { useState } from 'react'
import DownloadFile from '../Services/DownloadFile'
import { applicationService } from '../Services/ApplicationService'
import Button from '@material-ui/core/Button'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'

const SelectField = (props) => {
  const classes = useStyles()
  const {
    label,
    name,
    setLoadingTrue,
    setLoadingFalse,
    onValueChange,
    ...rest
  } = props

  const dropDownOptions = [
    {
      key: 'National Grid, Massachusetts',
      value: 'National Grid, Massachusetts',
      utility: 'National Grid',
      state: 'MA',
      app_form_url: '',
      tandc_form_url: '',
    },
    {
      key: 'National Grid, Rhode Island',
      value: 'National Grid, Rhode Island',
      utility: 'National Grid',
      state: 'RI',
      app_form_url: '',
      tandc_form_url: '',
    },
    {
      key: 'Eversource, Massachusetts',
      value: 'Eversource, Massachusetts',
      utility: 'Eversource',
      state: 'MA',
      app_form_url: '',
      tandc_form_url: '',
    },
    {
      key: 'Eversource, Connecticut',
      value: 'Eversource, Connecticut',
      utility: 'Eversource',
      state: 'CT',
      app_form_url: '',
      tandc_form_url: '',
    },
    {
      key: 'Cape Light Compact, Massachusetts',
      value: 'Cape Light Compact, Massachusetts',
      utility: 'Cape Light Compact',
      state: 'MA',
      app_form_url: '',
      tandc_form_url: '',
    },
  ]

  const [tandc_form_url, setTandc_form_url] = useState(null)
  const [app_form_url, setApp_form_url] = useState(null)
  const [show_links, setShow_links] = useState(false)
  const handleTandCDownload = () => {
    DownloadFile(tandc_form_url)
  }
  const handleAppFormDownload = () => {
    DownloadFile(app_form_url)
  }

  const onDropDownChange = (event) => {
    setLoadingTrue()
    applicationService.getForms()
      .then((list) => {
        dropDownOptions.forEach((option) => {
          list.forEach((item) => {
            if (
              option.utility === item.utility &&
              option.state === item.state
            ) {
              option.app_form_url = item.app_form_url
              option.tandc_form_url = item.tandc_form_url
            }
          })
        })
        dropDownOptions.forEach((option) => {
          if (option.key === event.target.value) {
            setTandc_form_url(option.tandc_form_url)
            setApp_form_url(option.app_form_url)
          }
        })
        setLoadingFalse()
      })
      .catch((error) => {
        setLoadingFalse()
      })
  }

  return (
    <div className={classes.formFieldOptions}>
      <InputLabel htmlFor={name} className={classes.formLabel}>
        {label}
        <ErrorMessage name={name} component={TextError} />
      </InputLabel>
      <FormControl>
        <InputLabel id="label">Select Your Answer</InputLabel>
        <Select
          labelid="label"
          id={name}
          name={name}
          {...rest}
          onChange={(event) => {
            onDropDownChange(event)
            onValueChange(event)
            setShow_links(true)
          }}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
          }}
          SelectDisplayProps={{ "data-testid": name }}
        >
          {dropDownOptions.map((option) => {
            return (
              <MenuItem key={option.key} value={option.value}>
                {option.key}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
      {show_links ? (
        <div className={classes.formDownloadFile}>
          <Button
            className={classes.formDownloadButton}
            variant="contained"
            onClick={handleAppFormDownload}
          >
            Download Application Form
          </Button>
          <Button
            className={classes.formDownloadButton}
            variant="contained"
            onClick={handleTandCDownload}
          >
            Download Terms and Conditions
          </Button>
        </div>
      ) : null}
    </div>
  )
}

export default SelectField
